"use strict";

import "./RightContainer.css";

import React from "react";

import openedDetailsStore from "./../../../store/openedDetails";
import displayedDetailsStore from "./../../../store/displayedDetails";

import {boundsLiteralToBounds} from "./../../../utils/geo";

import shouldComponentUpdate from "vwa/shouldComponentUpdate";

import Map from "./../../Map";
import VehicleDetails from "./../../VehicleDetails";
import POIDetails from "./../../POIDetails";
import UserSettings from "./../../UserSettings";

const DETAILS_DIVIDING_DENOMINATOR = 7;
const DETAILS_DEFAULT_HEIGHT_RATIO = 4;
const DETAILS_ANIMATION_DURATION = 300; // ms

export default class RightContainer extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
		this.setStoreListeners();
	}
	
	initState() {
		this.state = {
			showSettings: false,
			cat: false,
			readyForMap: false,
			openedDetails: openedDetailsStore.getAll(),
			displayedDetails: displayedDetailsStore.get(),
			detailsSize: 0
		};
	}
	
	setStoreListeners() {
		openedDetailsStore.on('change', openedDetails => this.setState({openedDetails, detailsSize: getDetailsSize()}));
		displayedDetailsStore.on('change', displayedDetails => this.setState({displayedDetails}));
	}
	
	shouldComponentUpdate(...nexts){
		return shouldComponentUpdate(this, ...nexts);
	}
	
	handleDisplayedDetailsSizeChange() {
		this.mapCenterAfterResize = this.mapCenterAfterResize || getCenterOfMap();
		if (!this.mapCenterAfterResize) return;
		
		if(this.mapSetterTimer){
			clearTimeout(this.mapSetterTimer);
		}
		
		this.mapSetterTimer = setTimeout(()=>{
			dispatcher.dispatch('setMap', {center: this.mapCenterAfterResize});
			this.mapSetterTimer = null;
			this.mapCenterAfterResize = null;
		}, DETAILS_ANIMATION_DURATION);
	}
	
	componentWillUpdate(_, nextState) {
		if(nextState.detailsSize != this.state.detailsSize){
			this.handleDisplayedDetailsSizeChange();
		}
	}
	
	componentDidMount() {
		this.setState({
			readyForMap: true
		});
	}

	onDragDetails(id, evt) {
		if(evt.clientY == 0){
			return;
		}
		
		const bounds = this.refs.rightContainer.getBoundingClientRect();
		const value = evt.y == 0 ? 0 : 1 - (evt.clientY - bounds.top)/bounds.height;
		const displayedDetailsSize = this.getDisplayedDetailsSize();
		
		if (value < 0){
			if(displayedDetailsSize != 0){
				dispatcher.dispatch("resizeDetails", id, 0);
			}
		}
		else if (value > 1){
			if(displayedDetailsSize != DETAILS_DIVIDING_DENOMINATOR){
				dispatcher.dispatch("resizeDetails", id, DETAILS_DIVIDING_DENOMINATOR);
			}
		}
		else{
			if(displayedDetailsSize != Math.round(value * DETAILS_DIVIDING_DENOMINATOR)){
				dispatcher.dispatch("resizeDetails", id, Math.round(value * DETAILS_DIVIDING_DENOMINATOR));
			}
		}
	}
	
	getDetailsHeightFromRatio(ratio) {
		return ratio * 100 / DETAILS_DIVIDING_DENOMINATOR
	}
	
	getDisplayedDetailsSize() {
		if (!this.state.displayedDetails || !this.state.openedDetails)
			return 0;
		const displayedDetailsDescriptor = this.state.openedDetails.find(od => od.id == this.state.displayedDetails.id);
		if (!displayedDetailsDescriptor)
			return 0;
		return displayedDetailsDescriptor.size || 0;
	}
		
	renderDetails(detailsDescriptor) {
		
		const className = (!this.state.displayedDetails || this.state.displayedDetails.id != detailsDescriptor.id) ? "Hidden" : "";
		
		if (detailsDescriptor.type == "VehicleDetails") {
			return (
				<VehicleDetails
					vehicleId={detailsDescriptor.id}
					key={detailsDescriptor.id}
					className={className}
					ondrag={evt => this.onDragDetails(detailsDescriptor.id, evt)}
				/>
			);
		}
		else if (detailsDescriptor.type == "POIDetails") {
			return (
				<POIDetails
					poiId={detailsDescriptor.id}
					key={detailsDescriptor.id}
					className={className}
					ondrag={evt => this.onDragDetails(detailsDescriptor.id, evt)}
				/>
			);
		}
		else null;
	}
	
	renderEveryDetails() {
		return this.state.openedDetails ? this.state.openedDetails.map(detailsDescriptor => this.renderDetails(detailsDescriptor)) : null;
	}
	
	renderUserSettings() {
		if(this.props.showSettings){
			return (<UserSettings onClose={this.props.onUserSettingsClose} />);
		}
		return null;
	}
	
	render() {
		const mapContainerStyle = {
			display: this.props.showSettings ? "none" : "flex",
			height: this.state.displayedDetails ? 100 - (this.getDetailsHeightFromRatio(this.getDisplayedDetailsSize())) + "%" : "100%"
		};
		
		const detailsContainerStyle = {
			display: (this.state.displayedDetails && !this.props.showSettings) ? "flex" : "none",
			height: this.getDetailsHeightFromRatio(this.getDisplayedDetailsSize()) + "%"
		};
		
		return (
			<div className="RightContainer" ref="rightContainer">
				<div id="mapContainer" style={mapContainerStyle} ref="mapContainer">
					<Map ref="map" ready={this.state.readyForMap} onCreatePOI={location => this.props.onCreatePOI(location)}/>
				</div>
				<div id="detailsContainer" style={detailsContainerStyle}>
					{this.renderEveryDetails()}
				</div>
				<div id="settingsContainer" className={!this.props.showSettings ?  "Hidden" : ""}>
					{this.renderUserSettings()}
				</div>
			</div>
		);
	}
	
}

function getDetailsSize() {
	if (!displayedDetailsStore.get())
		return null;
	if (!openedDetailsStore.get(displayedDetailsStore.get().id))
		return null;
	return openedDetailsStore.get(displayedDetailsStore.get().id).size;
}

function getCenterOfMap() {
	const mapState = mapStateStore.get();
	if (!mapState)
		return null;
	
	if ("center" in mapState)
		return mapState.center;
	else if ("bounds" in mapState)
		return boundsLiteralToBounds(mapState.bounds).getCenter().toJSON();
	else return null;
}


// WEBPACK FOOTER //
// ./src/view/Dashboard/RightContainer/RightContainer.jsx